import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export const AdditionalText = styled.div`
  color: ${() => Palette.PrimaryGray._700};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px 0;
  margin-bottom: ${({ isBottom }) => isBottom && '32px'};
`;
export const Required = styled.span`
  display: inline-block;
  color: ${() => Palette.Primary._700};
  font-size: 14px;
`;

export const SectionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldName = styled.div`
  color: ${() => Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  align-items: center;
  height: 24px;
  width: 105px;
  ${({ isRequired }) =>
    isRequired &&
    css`
      ::after {
        content: '*';
        color: ${Palette.Primary._700};
        margin-left: 2px;
      }
    `}
`;

export const Row = styled.div`
  display: flex;
  align-items: ${({ isStart }) => (isStart ? 'start' : 'center')};
  gap: 32px;
`;

export const SubField = styled.div`
  color: ${() => Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: center;
  width: 100px;
`;

export const PhoneRow = styled(Row)`
  height: 40px;
  margin-bottom: 10px;
`;

export const PhoneInputWrap = styled.div`
  position: relative;
  height: 40px;
`;
